export default __webpack_public_path__ + "static/Circle-5cf7018dd1337a518ecd5ed98d88d642.svg";